var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container master-detail" }, [
    _c(
      "div",
      { staticClass: "row" },
      [_c("search-area", { staticClass: "col-12" })],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "row search-loading__parent" },
      [
        _c(
          "transition",
          { attrs: { name: "fade-slide", mode: "out-in" } },
          [
            !_vm.detail
              ? _c("search-categories", { staticClass: "col-12" })
              : _vm._e(),
            _vm._v(" "),
            _vm.detail
              ? _c(
                  "div",
                  [
                    _c("div", { staticClass: "col-12" }, [
                      _c("div", { staticClass: "back-wrapper" }, [
                        _c("button", {
                          staticClass:
                            "button button--secondary back-button button--icon icon--before icon--arrow-left",
                          attrs: { "aria-label": "back" },
                          on: { click: _vm.back },
                        }),
                        _vm._v(" "),
                        _c("span", [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.localization.categories.all)),
                          ]),
                          _vm._v(" (" + _vm._s(_vm.totalResults) + ")"),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("search-results", { staticClass: "col-12" }),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }